import { isParentProduct } from "./stringUtils.js";
import { BRANDCLUB_BRAND_ID } from "./constants/Constants.js";
const BRANDCLUB_LOGO_URL = "https://media.brandclub.com/brandclub/image_asset/brandclub-b-logo.webp";
const BC_MEDIA_DOMAIN = "https://media.brandclub.com";
const BC_VIDEOS = {
  HOME_HEAD: {
    video: "https://media.brandclub.com/brandclub/media/home_head.mp4",
    coverImage: "https://media.brandclub.com/brandclub/media/cover/home_head.png"
  },
  DAVID: {
    video: "https://media.brandclub.com/brandclub/media/video_david.mp4",
    coverImage: "https://media.brandclub.com/brandclub/media/cover/video_david.png"
  },
  JESSICA: {
    video: "https://media.brandclub.com/brandclub/media/video_jessica.mp4",
    coverImage: "https://media.brandclub.com/brandclub/media/cover/video_jessica.png"
  },
  EMMA: {
    video: "https://media.brandclub.com/brandclub/media/video_emma.mp4",
    coverImage: "https://media.brandclub.com/brandclub/media/cover/video_emma.png"
  },
  ANGELA: {
    video: "https://media.brandclub.com/brandclub/media/video_angela.mp4",
    coverImage: "https://media.brandclub.com/brandclub/media/cover/video_angela.png"
  },
  MARCUS: {
    video: "https://media.brandclub.com/brandclub/media/video_marcus.mp4",
    coverImage: "https://media.brandclub.com/brandclub/media/cover/video_marcus.png"
  }
};
const BC_TESTIMONIALS = [
  {
    ...BC_VIDEOS.DAVID,
    name: "David R.",
    location: "Minneapolis, MN",
    testimonial: `“I can now earn cash back for purchases at Amazon, Walmart and Target.”`
  },
  {
    ...BC_VIDEOS.JESSICA,
    name: "Jessica P.",
    location: "Dallas, TX",
    testimonial: `“I can earn cash back whenever I shop online or in my favorite stores.”`
  },
  {
    ...BC_VIDEOS.EMMA,
    name: "Emma S.",
    location: "Phoenix, AZ",
    testimonial: `“Brandclub has an amazing affiliate program where I can earn up to 20% commission.”`
  },
  {
    ...BC_VIDEOS.ANGELA,
    name: "Angela W.",
    location: "Chicago, Il.",
    testimonial: `“Brandclub allows me to earn cash back for the items that are always in my shopping cart.”`
  },
  {
    ...BC_VIDEOS.MARCUS,
    name: "Marcus H.",
    location: "Boston, MA",
    testimonial: `“I can easily compare prices across Chewy, Amazon and other retailers.”`
  }
];
const getImageAssetUrl = (fileName, relativePath = "brandclub/image_asset", domain = BC_MEDIA_DOMAIN) => {
  return `${domain}/${relativePath}/${fileName}`;
};
const getAssetNameFromUrl = (fileUrl) => {
  const arr = fileUrl.split("/");
  if (arr.length > 0) {
    return arr[arr.length - 1];
  }
  return "";
};
const getFeaturedRetailerImage = (id) => {
  return `https://media.brandclub.com/retailer_logo/white/${id}.webp`;
};
const getEntityImage = (id, type, subId) => {
  if (type === "retailer") {
    return `https://media.brandclub.com/retailer_logo/${subId ?? id}.webp`;
  }
  if (type === "brand" && +id === 5e4) {
    return BRANDCLUB_LOGO_URL;
  }
  if (isParentProduct(`${id}`)) {
    return `https://s3-us-west-2.amazonaws.com/stackline-product-images/parent-products/${id}.jpg`;
  }
  return `https://s3-us-west-2.amazonaws.com/stackline-product-images/${id}.jpg`;
};
const getDefaultBrandclubImage = (brandId) => {
  return `https://media.brandclub.com/b/428x428/${brandId}.jpg`;
};
const getFallbackBrandclubImage = (brandId) => {
  return `https://media-api.brandclub.com/b/428x428/${brandId}.jpg`;
};
const getDefaultProductImage = (stacklineSku) => {
  return `https://media.brandclub.com/p/428x428/${isParentProduct(stacklineSku) ? "parent-products/" : ""}${stacklineSku}.jpg`;
};
const getFallbackProductImage = (stacklineSku) => {
  return `https://media-api.brandclub.com/p/428x428/${isParentProduct(stacklineSku) ? "parent-products/" : ""}${stacklineSku}.jpg`;
};
const resolveProductImageUrls = (product) => {
  var _a;
  const { stacklineSku } = product;
  const metadataUrl = (_a = product.imageUrls) == null ? void 0 : _a[0];
  if (metadataUrl) {
    return {
      src: metadataUrl,
      fallbackImage: getDefaultProductImage(stacklineSku)
    };
  }
  return {
    src: getDefaultProductImage(stacklineSku),
    fallbackImage: getFallbackProductImage(stacklineSku)
  };
};
const getBrandLogo = (brandId) => {
  if (brandId === BRANDCLUB_BRAND_ID) {
    return getImageAssetUrl(`${brandId}.svg`, "b/428x428");
  }
  return getImageAssetUrl(`${brandId}.jpg`, "b/428x428");
};
export {
  BC_MEDIA_DOMAIN,
  BC_TESTIMONIALS,
  BC_VIDEOS,
  getAssetNameFromUrl,
  getBrandLogo,
  getDefaultBrandclubImage,
  getDefaultProductImage,
  getEntityImage,
  getFallbackBrandclubImage,
  getFallbackProductImage,
  getFeaturedRetailerImage,
  getImageAssetUrl,
  resolveProductImageUrls
};
//# sourceMappingURL=assetUtils.js.map
